const DEFAULT_ICON_STROKE_COLOR = "#070708";
const DISABLED_ICON_STROKE_COLOR = "var(--color-secondary)";

type TDatePickerIconProps = {
  disable: boolean;
};

function DatePickerIcon({ disable }: TDatePickerIconProps) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 12H15M7 12H7.00898M12 16H7M15 16H14.991"
        stroke={disable ? DISABLED_ICON_STROKE_COLOR : DEFAULT_ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 1V3M5 1V3"
        stroke={disable ? DISABLED_ICON_STROKE_COLOR : DEFAULT_ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 11.2432C1.5 6.88594 1.5 4.70728 2.75212 3.35364C4.00424 2 6.01949 2 10.05 2H11.95C15.9805 2 17.9958 2 19.2479 3.35364C20.5 4.70728 20.5 6.88594 20.5 11.2432V11.7568C20.5 16.1141 20.5 18.2927 19.2479 19.6464C17.9958 21 15.9805 21 11.95 21H10.05C6.01949 21 4.00424 21 2.75212 19.6464C1.5 18.2927 1.5 16.1141 1.5 11.7568V11.2432Z"
        stroke={disable ? DISABLED_ICON_STROKE_COLOR : DEFAULT_ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 7H20"
        stroke={disable ? DISABLED_ICON_STROKE_COLOR : DEFAULT_ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export { DatePickerIcon };
